import React from 'react';
import { Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from '../Button/CustomButton';

const CustomSnackbar = ({
  open,
  onClose,
  message,
  severity,
  actionable,
  type = 'default', // 'default' or 'actionable'
}) => {
  const borderColors = {
    success: '#008000',
    error: '#CC0000',
    warning: '#FFBF40',
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return; // Don't close if user clicks away
    }

    onClose();
  };

  const action = (
    <>
      {type === 'actionable' && actionable && (
        <CustomButton
          variant='text'
          color='secondary'
          label={actionable.label}
          onClick={() => {
            if (actionable.onClick) {
              actionable.onClick();
            }
          }}
        />
      )}
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={4000}
      message={message}
      action={action}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        marginTop: '55px', // Add top margin for better spacing
      }}
      ContentProps={{
        sx: {
          backgroundColor: '#333333',
          color: 'white',
          borderLeft: severity
            ? `16px solid ${borderColors[severity]}`
            : 'none',
          padding: '8px 16px',
          boxShadow: `0px 2px 6px 1px #00000026,
                      0px 1px 2px 0px #0000004D`,
        },
      }}
    />
  );
};

export default CustomSnackbar;
